const content = [
  {
    caption: "Hebden Bridge's family-run takeaway",
    subCaption: 'See the menu',
    link: '/menu',
    image: 'http://jkschinesetakeaway.co.uk/images/noodle-dish.jpg',
  },
  {
    caption: 'The finest and freshest ingredients',
    subCaption: 'Call and order',
    link: '/contact-us',
    image: 'http://jkschinesetakeaway.co.uk/images/stir-fry.jpg',
  },
];

export default content;
